/**
 * Sanitize a string to be ready to used as regex input
 *
 * @param str the regex input
 * @returns the escaped regex input
 *
 * @comment the regex replace any special character
 */
export const sanitizeRegexInput = (str: string) => str.replace(/[#-.]|[[-^]|[?|{}]/g, '\\$&');
